import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=02943ece&"
import script from "@/controllers/ap/student/quiz/Quiz?v=3.1?vue&type=script&lang=ts&"
export * from "@/controllers/ap/student/quiz/Quiz?v=3.1?vue&type=script&lang=ts&"
import style0 from "@/assets/css/main.css?v=2.2?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports